globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.UnsubscriptionRequestsController = (function(superClass) {

    utils.extend(UnsubscriptionRequestsController, superClass);

    function UnsubscriptionRequestsController() {
        return UnsubscriptionRequestsController.__super__.constructor.apply(this, arguments);
    }

    $.extend(UnsubscriptionRequestsController.prototype, {
        init: function() {
            var $unsubscriptionRequestForm = $(".panel.panel-flat#unsubscription-request-form");
            var $selectUnsubscriptionReason = $unsubscriptionRequestForm.find("#unsubscription-request-unsubscription-reason .select");
            var $selectUnsubscriptionRequestMainQualifications = $unsubscriptionRequestForm.find(".unsubscription-request-main-qualifications");

            $selectUnsubscriptionReason.on("change", function() {
                var $this = $(this),
                    val = $this.val();

                $selectUnsubscriptionRequestMainQualifications.hide();
                $unsubscriptionRequestForm.find(`#unsubscription-request-${val}-fieldset`).fadeIn();
            });

            var $disappointing_service_inputs = $unsubscriptionRequestForm.find("#disappointing_service input");
            var $disappointing_service_other_input = $unsubscriptionRequestForm.find('input[name="business_services_website_agency_unsubscription_request[qualification_attributes][disappointing_service_other]"]');
            var $disappointing_service_other_description = $unsubscriptionRequestForm.find("#disappointing_service_other_description");
            $disappointing_service_inputs.on("change", function() {
                if($disappointing_service_other_input.is(":checked")) {
                    $disappointing_service_other_description.fadeIn();
                } else {
                    $disappointing_service_other_description.fadeOut();
                }
            });

            $activity_stopped_type_select = $unsubscriptionRequestForm.find("#activity_stopped_type select");
            $postponed_project_type = $unsubscriptionRequestForm.find("#postponed_project_type");
            $activity_stopped_type_select.on("change", function() {
                $(this).val() == "postponed_project" ? $postponed_project_type.fadeIn() : $postponed_project_type.fadeOut()
            });

            $provider_change_inputs = $unsubscriptionRequestForm.find("#provider_change input");
            $provider_change_name = $unsubscriptionRequestForm.find("#provider_change_name");
            $provider_change_inputs.on("change", function() {
                if(["agency", "self_service_tool"].includes($(this).val())) {
                    $provider_change_name.fadeIn();
                } else {
                    $provider_change_name.fadeOut();
                }
            });

            var $calendly_widget = $("body").find(".calendly-widget");
            var $calendly_input = $calendly_widget.find("#calendly-event-scheduled-datetime");
            if($calendly_input.length) {
                $("body").on("calendly_event_scheduled", function() {
                    appCustomerSpace.Loader().start({ $container: $('.content'), options: {text: false, icon_size: '3x'}});
                    $.post(
                        $calendly_widget.data("remote-url"),
                        { datetime: $calendly_input.val() },
                        function(response) {
                            setTimeout(function() {
                                window.location.href = response.redirect_url;
                            }, 3000);
                        }
                    )
                });
            }

            return UnsubscriptionRequestsController.__super__.init.apply(this, arguments);
        }
    });

    return UnsubscriptionRequestsController;
})(appCustomerSpace.Controllers.LocalManagement.MainController);
